export default __webpack_public_path__ + "static/media/ncxwhitelogo.023374cf.svg";